export const activitiesRoutes = {
  create: [],
  view: [
    {
      path: 'activities',
      title: `trip activities`,
      loadComponent: () =>
        import('./pages/activities-section/activities-section.page').then(
          (m) => m.ActivitiesSectionPage,
        ),
    },
  ],
};
